import { T } from '@/ui/tokens';
import { fmt } from '@/ui/utils/format';
import { CoinGlyph } from './CoinGlyph';

export function CoinBalance({ amount, label, large }: { amount: number | bigint; label?: string; large?: boolean }) {
  return (
    <div>
      {label && (
        <div style={{
          fontSize: 11, color: T.textMute, textTransform: 'uppercase',
          letterSpacing: 1, fontWeight: 500,
        }}>{label}</div>
      )}
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginTop: large ? 6 : 2 }}>
        <CoinGlyph size={large ? 24 : 18}/>
        <span style={{
          fontFamily: T.fontMono, fontSize: large ? 36 : 22, fontWeight: 500,
          color: T.text, letterSpacing: -1, fontVariantNumeric: 'tabular-nums',
        }}>
          {fmt(amount)}
        </span>
        <span style={{ color: T.accent, fontSize: large ? 14 : 12, fontWeight: 600 }}>C</span>
      </div>
    </div>
  );
}
